import React, { Fragment, Component } from "react";
import {
	Container,
	Row,
	Col,
	CardBody,
	Card,
	CardTitle,
	CardSubtitle,
	Button,
	Fieldset,
	Legend,
	Table
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
	AvForm,
	AvGroup,
	AvInput,
	AvField,
	AvCheckboxGroup,
	AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import moment from "moment";

var reformatEmployee = function (employee) {
	return employee.map(function (region) {
		var newObj = {};
		newObj["label"] = region.employee_nip + " - " + region.employee_full_name;
		newObj["value"] = region.employee_uuid;
		newObj["model"] = region;
		return newObj;
	});
};

var reformatRank = function (ranks) {
	return ranks.map(function (rank) {
		var newObj = {};
		newObj["label"] = rank.rank_name;
		newObj["value"] = rank.rank_uuid;
		newObj["model"] = rank;
		return newObj;
	});
};

var reformatType = function (regions) {
	return regions.map(function (region) {
		var newObj = {};
		newObj["label"] = region.retired_type_name;
		newObj["value"] = region.retired_type_uuid;
		return newObj;
	});
};


class IndexView extends Component {
	createBloc = new CreateBloc();
	queryParams = new URLSearchParams(window.location.search)
    userdata = JSON.parse(localStorage.getItem('userdata'));

	constructor(props) {
		super(props);
		this.state = {
			peg_uuid : "",
			isLoadingOptEmployee: true,
			listExclude: [],
			dataForm: {
				financial_revision_period_uuid : props.uuid,
			},
			employeeItems: [],
			rankItems: [],
			employeeSelected: props.pegawai_uuid,
			pangkatSelected: "",
			typeItems: [],
			typeSelected: "",
			rankGroupRoom: "",
		};

	}

	addList = () => {
		let emp = this.state.selectedEmployee;
		let obj = {
			uuid: emp.employee_uuid,
			nip: emp.employee_nip,
			nama: emp.employee_full_name
		}
		let temp = this.state.listExclude.filter((val) => val.nip != emp.employee_nip)
		temp.push(obj);
		//console.log(temp)

		this.setState({
			listExclude: temp
		})
	}

	deleteList = (data) => {
		this.setState({
			listExclude: [
				...this.state.listExclude.filter((val) => val.nip != data.nip)
			]
		})
	}

	submitData = async () => {
		const formData = generateFormData(this.state.dataForm); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
		await this.createBloc.fetchCreate(formData);
	};

	handlerOnSubmit = (e, values) => {
		e.preventDefault();
		var list_pegawai_nip = [];
		var list_pegawai_uuid = [];
		var idx = 0;
		(this.state.listExclude).forEach((el)=>{
			list_pegawai_nip[idx] = el.nip;
			list_pegawai_uuid[idx] = el.uuid;
			console.log(el)
			idx++;
		})
		var peg_uuid = (this.userdata != null ? this.userdata.employee_uuid : "");
		console.log()
		this.setState({
			dataForm: {
				financial_revision_period_uuid : this.queryParams.get('uuid'),
				financial_revision_employee_nip : list_pegawai_nip,
				financial_revision_employee_uuid : list_pegawai_uuid,
				peg_uuid : peg_uuid,
				...values,
			},
			confirm: true,
		});
		console.log(this.state.dataForm);
	};

	

	confirmResponse = (response) => {
		let forState = {};
		switch (response) {
			case "cancel":
				forState = {
					confirm: false,
				};
				break;
			case "confirm":
				forState = {
					loading: true,
					confirm: false,
				};
				this.submitData();
				break;
			case "success":
				forState = {
					success: false,
					redirect: true,
				};
				break;
			case "failed":
				forState = {
					failed: false,
				};
				break;
			default:
		}
		this.setState(forState);
	};

	componentDidMount() {
		this.createBloc.createChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					this.setState({
						loading: false,
						success: true,
					});
					break;
				case apiResponse.ERROR:
					this.setState({
						loading: false,
						failed: true,
					});
					break;
				default:
					break;
			}
		});

		this.createBloc.employeeChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response;
						console.log(response.result)
						this.setState({
							employeeItems: reformatEmployee(response.result),
							isLoadingOptEmployee : false
						});
					}
					break;
				case apiResponse.ERROR:
					break;
				default:
					break;
			}
		});

		

		this.createBloc.detailChannel.subscribe((result) => {
			switch (result.status) {
				case apiResponse.COMPLETED:
					if (result.data.status) {
						let response = result.data.response;
						this.setState({
							detailPeriode: response
						});
					}
					break;
				case apiResponse.ERROR:
					break;
				default:
					break;
			}
		});

		this.createBloc.fetchEmployee();

		this.createBloc.fetchDetail({ uuid: this.queryParams.get('uuid') });
	}

	componentWillUnmount() {
		this.createBloc.createChannel.unsubscribe()
		this.createBloc.employeeChannel.unsubscribe()
		this.createBloc.typeChannel.unsubscribe()
		this.createBloc.detailChannel.unsubscribe()
		this.createBloc.rankChannel.unsubscribe()
	}

	render() {
		return (
			<Fragment>
				<Container fluid>
					<Row>
						<Col className="col-12">
							<Card className="">
								<CardBody>
									<CardTitle>Tambah Data Revisi Pegawai</CardTitle>
									<CardSubtitle className="mb-3">
										Setiap isian yang bertanda (
										<span className="text-danger ">*</span>) adalah wajib diisi.
									</CardSubtitle>
									<hr />
									<AvForm
										className="needs-validation"
										onValidSubmit={(e, values) =>
											this.handlerOnSubmit(e, values)
										}
									>
										<Row className="mb-3">
											<label
												htmlFor="xxx"
												className="col-md-3 col-form-label"
											>
												Pegawai <span className="text-danger">*</span>
											</label>
											<Col md="5">
												<CustomSelect
													name={`xxx`}
													errorMessage="Pilih Pegawai"
													options={this.state.employeeItems}
													validate={{ required: { value: true } }}
													placeholder="Pilih Pegawai"
													isLoading={this.state.isLoadingOptEmployee}
													onChange={
														(v) => this.setState({
															selectedEmployee: v.model
														})
													}
												// defaultValue={data.type}
												/>
											</Col>
											<Col md="2">
												<Button className="btn-block waves-effect waves-light mb-1 btn btn-primary"
													color="success"
													type="button"
													onClick={() => this.addList()}
													disabled={this.state.selectedEmployee != null ? false : true}
												><i className="uil-plus-circle"></i>
												</Button>
											</Col>
										</Row>
										<Row className="mb-3">
											<label
												htmlFor="no_sk"
												className="col-md-3 col-form-label"
											>
												Daftar Revisi Pegawai
											</label>
											<Col md="8">
												<Table className='table-striped table-bordered table-sm'>
													<thead>
														<tr>
															<td className='text-center' width='100'>No</td>
															<td className='text-center' width='30%'>NIP</td>
															<td className='text-center' width='60%'>Nama</td>
															<td className='text-center' width='100'>Aksi</td>
														</tr>
													</thead>
													<tbody>
														{
															this.state.listExclude.length > 0 ?

																this.state.listExclude.map((data, index) => {
																	return (
																		<tr>
																			<td className='text-center align-middle'>{index += 1}</td>
																			<td className='align-middle'>{data.nip}</td>
																			<td className='align-middle'>{data.nama}</td>
																			<td className='text-center align-middle'>
																				<Button className="btn btn-danger btn-sm"
																					color="danger"
																					type="button"
																					onClick={() => {
																						this.deleteList(data)
																					}}
																				><i className="uil-trash-alt"></i>
																				</Button>
																			</td>
																		</tr>
																	);
																})

																:
																<tr>
																	<td colSpan="4" className="text-center">Tidak Ada Data</td>
																</tr>
														}
													</tbody>
												</Table>
											</Col>
										</Row>
										<Row className="mb-3">
											<Col md="3"></Col>
											<Col md="9">
												<Link to={`?pegawai&uuid=` + this.props.uuid}>
													<Button color="danger">
														<i className="uil-arrow-left"></i> Kembali
													</Button>
												</Link>{" "}
												<Button color="success" type="submit">
													<i className="uil-arrow-up-right"></i> Simpan Data
												</Button>
											</Col>
										</Row>
									</AvForm>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Container>
				<ConfirmAlert
					confirmTitle="Konfirmasi!"
					confirmInfo="Apakah anda yakin akan menyimpan data ini?"
					loadingTitle="Mengirim data..."
					loadingInfo="Tunggu beberapa saat"
					successTitle="Berhasil!"
					successInfo="Data berhasil disimpan"
					failedTitle="Gagal!"
					failedInfo="Data gagal disimpan"
					showConfirm={this.state.confirm}
					showLoading={this.state.loading}
					showSuccess={this.state.success}
					showFailed={this.state.failed}
					response={this.confirmResponse}
				/>
				{this.state.redirect ? (
					<Redirect
						to={
							`/kepegawaian/revisi_keuangan.html?pegawai&uuid=` +
							this.props.uuid
						}
					/>
				) : null}
			</Fragment>
		);
	}
}

export default IndexView;
